var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path2, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4987 1.8H15.4431C16.482 1.8 17.332 2.61 17.332 3.6V16.2C17.332 17.19 16.482 18 15.4431 18H2.22092C1.17259 18 0.332031 17.19 0.332031 16.2L0.341476 3.6C0.341476 2.61 1.17259 1.8 2.22092 1.8H3.16536V0H5.05425V1.8H12.6098V0H14.4987V1.8ZM2.22092 16.2H15.4431V6.3H2.22092V16.2Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.40625,
    y: 8.23242,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.76758,
    y: 9.55127,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.76758,
    y: 10.8701,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.76758,
    y: 12.189,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.76758,
    y: 13.5083,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.72461,
    y: 8.23242,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.08594,
    y: 9.55127,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6.08594,
    y: 10.8701,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 6.08594,
    y: 12.189,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 6.08594,
    y: 13.5083,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 10.043,
    y: 8.23242,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 7.40625,
    y: 9.55127,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 7.40625,
    y: 10.8701,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 7.40625,
    y: 12.189,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 7.40625,
    y: 13.5083,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3613,
    y: 8.23242,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72461 9.55127H9.38407V10.2107H8.72461V9.55127Z",
    fill: "currentColor"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 8.72461,
    y: 10.8701,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 8.72461,
    y: 12.189,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 8.72461,
    y: 13.5083,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3613,
    y: 9.55127,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3613,
    y: 10.8701,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3613,
    y: 12.189,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6816,
    y: 8.23242,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 10.043,
    y: 9.55127,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 10.043,
    y: 10.8701,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 10.043,
    y: 12.189,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 10.043,
    y: 13.5083,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6816,
    y: 9.55127,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6816,
    y: 10.8701,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6816,
    y: 12.189,
    width: 0.659457,
    height: 0.659457,
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.832,
    cy: 15,
    r: 4,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.828 11C12.62 11 10.832 12.792 10.832 15C10.832 17.208 12.62 19 14.828 19C17.04 19 18.832 17.208 18.832 15C18.832 12.792 17.04 11 14.828 11ZM14.832 18.2C13.064 18.2 11.632 16.768 11.632 15C11.632 13.232 13.064 11.8 14.832 11.8C16.6 11.8 18.032 13.232 18.032 15C18.032 16.768 16.6 18.2 14.832 18.2ZM14.432 15.428L16.628 16.744L17.036 16.056L15.232 14.972V12.768H14.432V15.428Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c79e466df4138b5edc566adf688e3f3c.svg";
export { ForwardRef as ReactComponent };